import { useVista, useModel, Vista, ViewModel, core } from "@essenza/react";
import { PatientModel } from "../data/patientmodel";
import { Divider, notification, Radio, Table } from "antd";
import { Patient, PatientVM } from "../widget/patient/form";
import { useMemo } from "react";

export function FoldersVista() {
    const vm = useVista(FoldersVVM);

    const [model, data] = useModel(PatientModel);

    vm.$$init(vm => {
        model.detail(vm.context.navdata);
    });

    const col = useMemo(() => Cols(vm), [vm])

    if (!data) return;

    return (
        <Vista>
            {data &&
                <div className="flex gap-2">
                    <button className="btn-dark bg-pri mt-2" onClick={() => vm.context.navigate("attachment", { idfolder: 0, source: data.attachments, idpatient: data.id })}>DOCUMENTI {data.attachments ? ('(' + data.attachments.length + ')') : ''}</button>
                    <div className="flex-auto"></div>
                    <button className="btn-dark bg-pri mt-2" onClick={() => vm.emit("EDIT", data)}>AGGIORNA</button>
                </div>}
            <Patient source={data} />
            <Divider>CARTELLE CLINICHE</Divider>
            <Radio.Group className="mb-2" value={vm.kind} onChange={e => vm.onchange(e.target.value)} options={[
                { value: 0, label: "Medicina Sportiva" },
                { value: 1, label: "Fisioterapia" },
            ]}>

            </Radio.Group>
            <Table dataSource={data?.folders?.filter(f => f.itype === vm.kind)} columns={col} pagination={false} />
        </Vista>
    )
}

export function FoldersVVM() {
    ViewModel.call(this);
    this.kind = 0;
    //this.use(BookVisitaVM).listen("SELECT")
    this.bind(PatientVM).as("patient");
}

core.prototypeOf(ViewModel, FoldersVVM, {
    onchange(v) {
        this.kind = v;
        this.update();
    },

    intent: {
        DETAIL({ data }) {
            this.context.navigate("folder", data.id);
        },
        
        async EDIT({ data }) {
            const validation = await this.patient.form.validate(true);

            if (validation.isValid) {
                data.save().then(() => notification.success({ message: "Dati aggiornati" }));
            }
        }
    }
});

function Cols(vm) {
    return [
        {
            title: "Numero",
            dataIndex: "id",
            key: "id",
            width: 70,
        },
        {
            title: "Data",
            dataIndex: "idate",
            key: "id",
            width: 'auto',
        },
        {
            title: "Tipo",
            render: (text, record) => record.itype === 0 ? ("CERTIFICATO " + (record.icertificate === 2 ? "NON" : "") + "AGONISTICO") : "FISIOTERAPIA",
            key: "fullname",
            width: 220,
        },
        {
            title: "Data certificato",
            dataIndex: "certdate",
            key: "id",
            width: 'auto',
        },
        {
            title: "Scadenza",
            dataIndex: "certex",
            key: "id",
            width: 'auto',
        },
        {
            title: "",
            key: "id",
            render: (text, record) => {
                return (
                    <button className="btn-dark bg-sec w-full" onClick={() => { vm.emit("DETAIL", record); }} >VISUALIZZA</button>
                );
            },
            width: 60,
        },
    ];
}